import UpdateChartNotificationInterface from "@app/Interface/UpdateChartNotificationInterface";
import ThresholdType from "@app/Type/ThresholdType";

export default class UpdateChartNotificationModel implements UpdateChartNotificationInterface {
    userID: number;
    fpuID: number;
    chart: string;
    active: boolean;
    thresholdRange: ThresholdType;
    thresholdMin: number;
    thresholdMax: number;
    
    constructor() {
        this.userID = 0;
        this.fpuID = 0;
        this.chart = "";
        this.active = false;
        this.thresholdRange ="above";
        this.thresholdMin = 0;
        this.thresholdMax = 0;
    }

}